import type {FormControl} from './forms/form-control';

export function touched(node, { formControl, touchTriggerEvent = 'blur', touchedClass = 'touched' }: {formControl: FormControl<unknown>, touchTriggerEvent?: string, touchedClass?: string}) {

    if (formControl.isTouched() && !node.classList.contains(touchedClass)) {
        node.classList.add(touchedClass);
    }

    const blurHandler = () => {
        if (!formControl.isTouched()) {
            formControl.setTouched();
            if (!node.classList.contains(touchedClass)) {
                node.classList.add(touchedClass);
            }
        }
    };

    node.addEventListener(touchTriggerEvent, blurHandler);
    return {
        destroy() {
            node.removeEventListener(touchTriggerEvent, blurHandler);
        }
    };
}